/**
 * Constantes do contrato AIOBI ↔ APM 009/2026 (PROMPT_DASHBOARD §2.5).
 * Valores hardcoded por serem parte do contrato (não derivam do .xlsx).
 * NUNCA alterar sem autorização do João.
 */

export const CONTRATO_INICIO = new Date(Date.UTC(2026, 2, 16)); // 16/03/2026
export const CONTRATO_FIM = new Date(Date.UTC(2027, 2, 15)); // 15/03/2027
export const DIAS_CONTRATO = 365;

/** Fee mensal s/IVA (cláusula 3.ª n.º 2 do CE). */
export const FEE_MENSAL = 990.0;
/** Fee proporcional Mar/26 (16 dias de 31). */
export const FEE_MAR_2026 = 510.97;
/** Fee proporcional Mar/27 (15 dias de 31). */
export const FEE_MAR_2027 = 479.03;

/** IVA Madeira 22% — NUNCA usar 23% mainland. */
export const IVA_AIOBI = 0.22;

/** Prazos de pagamento (dias seguidos, cláusula 4.ª n.º 5). */
export const PRAZO_PAGAMENTO_PLAT = 30;
export const PRAZO_PAGAMENTO_FEE = 60;

/** Entidades. */
export const NIPC_AIOBI = 'PT517258277';
export const NIPC_APM = 'PT511236077';

/** Nome legal completo do prestador. */
export const RAZAO_SOCIAL_AIOBI = 'LEGÍVEL & PORTÁTIL, LDA.';
export const MARCA_COMERCIAL = 'AIOBI';

/** Stakeholders APM principais (info de display — emails NUNCA usados pelo dashboard). */
export const APM_STAKEHOLDERS = {
  contractManager: 'Filipa Silva',
  president: 'Sara Marote',
} as const;
